import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import {
  useEditSecondaryCriteriaTemplate,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function EditSecondaryCriteriaTemplate({
  scope,
  namespace,
  nextTemplate,
  elementType,
  isDangerous,
  cancel,
}: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { isRequestPending, editSecondaryCriteriaTemplate } =
    useEditSecondaryCriteriaTemplate(planzone.uuid, elementType);

  return (
    <Modal
      header={t("editSecondaryCriteriaTemplate.title")}
      headerClassName={classNames({ [styles.header]: isDangerous })}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("editSecondaryCriteriaTemplate.message")}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("editSecondaryCriteriaTemplate.cancel")}
          </Button>
          <Button
            type={isDangerous ? "delete" : "submit"}
            status={isRequestPending ? "pending" : "none"}
            press={() =>
              editSecondaryCriteriaTemplate({
                namespace,
                scope,
                nextTemplate,
                elementType,
              })
            }
          >
            {t("editSecondaryCriteriaTemplate.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { EditSecondaryCriteriaTemplate };
